import React from "react";
import UserDetailsHeader from "../../../../UserDetailsHeader";
import { Typography } from "@mui/material";
import videothumbnailIcon from "../../../../../../assets/images/HowtoTestVideoThumbnail.svg";
import "../../howToTest/howToTest.scss";
import prerequisitesImg from "../../../../../../assets/images/HowToTest/TugFront/prerequistes.png";
import setupImg from "../../../../../../assets/images/HowToTest/TugSide/setup.png";
import performTestImg from "../../../../../../assets/images/HowToTest/TugSide/performTest.png";
import uploadImg from "../../../../../../assets/images/HowToTest/TugFront/upload.png";
import setupForJP from "../../../../../../assets/images/HowToTest/TugSide/setupForJP.png";
import uploadForJP from "../../../../../../assets/images/HowToTest/TugFront/uploadForJP.png";
import { getParams } from "../../../../../../utlis/helpers";
import { pageLocale } from "../../../../../../utlis/locale";

const HowtoTestTugSide = () => {
  const { locale } = getParams();
  const videoPlayHandler = (link) => {
    window.open(link, "_blank");
  };
  const {
    armless_chair_desc,
    phone_stand_desc,
    support_desc,
    setup1,
    setup2,
    setup3,
    upload1,
    upload2,
  } = pageLocale("tugFront");

  const { setup4, perform1, perform2, perform3, perform4, setupnewAdd } =
    pageLocale("tugSide");
  const {
    how_to,
    playlist,
    test_guide,
    support_person_guidelines,
    general_guide,
    armless_chair,
    phone_stand,
    support_person,
    step_guide,
    step_one,
    step_two,
    step_three,
    step_four,
    disable_wide,
    disable_wide_desc,
  } = pageLocale("common");
  const getInfo = JSON.parse(sessionStorage.getItem("testDescription"));
  const playlistItem = [
    {
      title: `1. ${test_guide}`,
      urlEN: `https://youtu.be/PW87Z8W7XJ0`,
      urlJP: `https://youtu.be/u33GEnptfUE`,
    },
    {
      title: `2. ${support_person_guidelines}`,
      urlEN: `https://youtu.be/jdexqsfzGQA`,
      urlJP: `https://youtu.be/FMdKekBExPE`,
    },
    {
      title: `3. ${general_guide}`,
      urlEN: `https://youtu.be/Qb3T992cBRg`,
      urlJP: `https://youtu.be/O3FCaxYYFN0`,
    },
  ];

  const prerequisitesStepsItem = [
    {
      title: armless_chair,
      description: armless_chair_desc,
    },
    {
      title: phone_stand,
      description: phone_stand_desc,
    },
    {
      title: support_person,
      description: support_desc,
    },
    {
      title: disable_wide,
      description: disable_wide_desc,
    },
  ];
  return (
    <>
      <UserDetailsHeader>
        <div className="how-to-test-main-wrapper">
          <Typography className="title">
            {getInfo?.moduleName}: {how_to}
          </Typography>
          <div className="test-instruction-wrapper">
            <Typography className="test-instruction-title">
              {playlist}
            </Typography>
            {playlistItem?.map((item, index) => {
              return (
                <div
                  className="video-playlist"
                  key={index}
                  onClick={() =>
                    videoPlayHandler(locale === "en" ? item.urlEN : item.urlJP)
                  }
                >
                  <div>
                    <img src={videothumbnailIcon} alt="thumbnail" />
                  </div>
                  <div>
                    <Typography>{item.title}</Typography>
                  </div>
                </div>
              );
            })}
            <Typography className="test-instruction-title">
              {step_guide}
            </Typography>
            <div className="steps-one">
              <Typography className="test-instruction-title">
                1. {step_one}
              </Typography>
              <img
                src={prerequisitesImg}
                alt="prerequisites"
                className="img one"
              />
              {prerequisitesStepsItem?.map((item, index) => {
                return (
                  <div className="prerequisites-step" key={index}>
                    <Typography className="step-title">{item.title}</Typography>
                    <Typography className="description">
                      {item.description}
                    </Typography>
                  </div>
                );
              })}
              <div className="test-step-divider"></div>
            </div>
            <div className="step-two">
              <Typography className="test-instruction-title">
                2. {step_two}
              </Typography>
              {locale === "en" ? (
                <img src={setupImg} alt="steup" className="img tug-side" />
              ) : (
                <img src={setupForJP} alt="steup" className="img tug-side" />
              )}
              <ul className="list-instruction">
                <li>{setup1}</li>
                <li dangerouslySetInnerHTML={{ __html: setup2 }}></li>
                <li dangerouslySetInnerHTML={{ __html: setup3 }}></li>
                <li dangerouslySetInnerHTML={{ __html: setupnewAdd }}></li>
                <li dangerouslySetInnerHTML={{ __html: setup4 }}></li>
              </ul>
              <div className="test-step-divider"></div>
            </div>
            <div className="step-three">
              <Typography className="test-instruction-title">
                3. {step_three}
              </Typography>
              <img
                src={performTestImg}
                alt="perform-test"
                className="img tug-side"
              />
              <ul className="list-instruction">
                <li>{perform1}</li>
                <li>{perform2}</li>
                <li dangerouslySetInnerHTML={{ __html: perform3 }}></li>
                <li>{perform4}</li>
              </ul>
              <div className="test-step-divider"></div>
            </div>
            <div className="step-four">
              <Typography className="test-instruction-title">
                4. {step_four}
              </Typography>
              {locale === "en" ? (
                <img src={uploadImg} alt="steup" className="img" />
              ) : (
                <img src={uploadForJP} alt="steup" className="img" />
              )}
              <ul className="list-instruction">
                <li dangerouslySetInnerHTML={{ __html: upload1 }}></li>
                <li dangerouslySetInnerHTML={{ __html: upload2 }}></li>
              </ul>
            </div>
          </div>
        </div>
      </UserDetailsHeader>
    </>
  );
};

export default HowtoTestTugSide;
